import { Svg } from "common/assets";
import { Config } from "common/config";
import { EColors } from "common/styles";
import { Fade } from "react-awesome-reveal";
import { Styled } from "components/Styled";

import { Component } from "./component";
import {  ButtonHero, ButtonIcon, ContainerHero, StyledHeroWrapper, StyledMainSection } from "./styled";
import { useEffect, useState } from "react";

export const Main = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = () => {
    window.location.href = `#${Config.Section.findUs}`;
  };

    useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 0);
    }, [isVisible]);
  
  return (
    <StyledMainSection>
      <ContainerHero style={{ opacity: isVisible ? 1 : 0 }}>
        <StyledHeroWrapper>
          <Component.TitleHero />
          <Fade direction="left" triggerOnce delay={600} cascade>
          <Styled.PBody1 color={EColors.white}>
            Завітайте до нас, щоб отримати найкращу якість пального прямо від
            європейських постачальників.
          </Styled.PBody1>
          <ButtonHero
            type='button'
            width="351px"
            height="60px"
            title="Переглянути АЗС на мапі"
            onClick={handleClick}>
            <ButtonIcon>
               <use href={Svg.sprite + "#icon-pin"} />
            </ButtonIcon> 
          </ButtonHero>
         </Fade>
        </StyledHeroWrapper>
        <Component.Products />
      </ContainerHero>
    </StyledMainSection>
  );
};
